import { DEFAULT_CURRENCY } from "@repo/shared";
import { useParams } from "react-router";

import {
  useAssetClasses,
  usePortfolioCollectionSettings,
} from "@/lib/hooks/use-portfolio-collections";

import { TableCardSkeleton } from "../skeleton-loaders";
import { AssetClassesTable } from "./asset-classes-table";

export default function AssetClassesPage() {
  const { id } = useParams<{ id: string }>();
  const { assetClasses, isLoading } = useAssetClasses(id!);
  const { settings } = usePortfolioCollectionSettings(id!);

  if (isLoading) {
    return <TableCardSkeleton columns={5} />;
  }

  return (
    <AssetClassesTable
      portfolioCollectionId={id!}
      assetClasses={assetClasses}
      currency={settings?.currency ?? DEFAULT_CURRENCY}
      riskFreeRatePct={settings?.riskFreeRatePct ?? 2.5}
      calculationsMode={settings?.calculationsMode ?? "asset_classes"}
    />
  );
}
